export const LOADED_BOOK = 'bookStore/loadedBooks';
export const ADD_BOOK = 'bookStore/addBook';
export const UPDATE_BOOK = 'bookStore/updateBook';
export const EDIT_BOOK = 'bookStore/editBook';
export const DELETE_BOOK = 'bookStore/deleteBook';
